import useMediaQuery from "@shared/hooks/useMediaQuery/useMediaQuery";
import breakpoints from "@shared/theme/props/breakpoints";
import Modal from "@ui-kit/overlays/Modal/Modal.web";
import { useTranslation } from "next-i18next";
import React from "react";
import HelpAndInfo from "./HelpAndInfo";

type HelpAndInfoModalSelectonProps = {
  venueRefundPolicy: string;
  isOpen: boolean;
  onClose: () => void;
};

const HelpAndInfoModalSelecton: React.FC<HelpAndInfoModalSelectonProps> = ({
  venueRefundPolicy,
  isOpen,
  onClose,
}): JSX.Element => {
  const { t } = useTranslation("common");
  const [isSmallerThanXs] = useMediaQuery(`(max-width: ${breakpoints.xs}px)`);

  return (
    <Modal
      scrollBehavior="inside"
      size={isSmallerThanXs ? "full" : "2xl"}
      isOpen={isOpen}
      isCentered
      data-testid="default-modal-container-wrapper"
      onClose={onClose}
      variant="informational"
    >
      <Modal.Header data-testid="default-modal-header" onClose={onClose}>
        {t("Help & Info")}
      </Modal.Header>
      <Modal.Body>
        <HelpAndInfo venueRefundPolicy={venueRefundPolicy} />
      </Modal.Body>
    </Modal>
  );
};

export default HelpAndInfoModalSelecton;
